import React,{Component} from 'react'
import axios from 'axios'
import querystring from 'querystring'
import clone from 'clone'
import Modal from 'react-bootstrap-modal'
import ImageZoom from 'react-medium-image-zoom'

import * as config from "../../config"
import Spinner from '../Shared/Spinner'
import EditableText from '../Shared/EditableText'
import Pager from '../Shared/Pager'
import Checkbox from '../Shared/Checkbox'

import moment from 'moment';
import "moment/locale/ru";

let timeout;
let timeout2;

class Product extends Component{
    constructor(props){
        super(props)
        this.state ={
            companyId:this.props.companyId,
            modalIsOpen:false,
            modalDetailsIsOpen:false,
            fetching:false,
            data:[],
            searchText:"",
            barcode:"",
            page:1,
            size:25,
            total:0,
            offerId:this.props.data.offerId
        }
    }
    handleProductClick(e){
        let {data} = this.props;
        let id = this.props.data.offerId;

        this.setState({
            modalIsOpen:true
        })

    }
    handleBarcodeClick(e){
        let {data} = this.props;
        let id = this.props.data.offerId;

        this.setState({
            modalDetailsIsOpen:true
        })
    }
    handleOnSaveOffer(field,value){
        let offerModel =clone(this.props.data);
        offerModel[field] = value;
        this.fucnSaveOffer(offerModel);
    }
    handleSearchChange(e){
        clearTimeout(timeout);
        let val = e.target.value;
        this.setState({
            searchText:val,
            page:1
        });

        timeout = setTimeout(()=>{
           this.getItems()
        },400)
    }
    handleBarcodeChange(e){
        clearTimeout(timeout2);
        let val = e.target.value;
        this.setState({
            barcode:val,
            page:1
        });

        timeout2 = setTimeout(()=>{
            this.getItems()
        },400)
    }

    getItems(){
        const {searchText, barcode} = this.state;

        if(searchText.trim().length > 0 || barcode.trim().length >0){
            this.setState({
                fetching:true,
                offerId:null,
                data:[]
            },()=>{
                axios.get(
                    config.apiUrl + "/offers/search",
                    {
                        params:{
                            companyId:this.state.companyId,
                            searchText:this.state.searchText,
                            offset:((this.state.page-1) * this.state.size),
                            barcode:this.state.barcode
                        }
                    }
                ).then((response)=>{
                    this.setState({
                        data:response.data.content.rows,
                        total:response.data.content.totalNumberOfResults,
                        fetching:false
                    })
                })
                    .catch((err)=>{
                        this.setState({
                            fetching:false
                        })
                    })
            })
        }
    }
    handleCopyName(e){
        this.setState({
            searchText:this.props.data.offerBindToName
        },()=>{
            this.getItems()
        });
    }
    handlePagerChange(pager){
        this.setState({
            page:pager.page
        },()=>{
            this.getItems()
        })
    }
    handleBindingClick(offerId){
        this.setState({
            offerId:offerId
        })
    }
    handleCheckboxChange(checked){
        if(this.props.onCheckboxChange !== undefined){
            this.props.onCheckboxChange(checked);
        }
    }

    closeModal() {
        this.setState({
            modalIsOpen: false,
            modalDetailsIsOpen: false,
            data:[],
            offerId:null,
            total:0,
            page:1
        });
    }
    saveModal(){
        this.handleOnSaveOffer("offerId",this.state.offerId);
        this.closeModal();
    }

    fucnSaveOffer(offerModel){

        if(offerModel.coefficient == null){
            offerModel.coefficient = 1;
            offerModel.isAutoBinded = 0;
        }
        axios.post(
            config.apiUrl + "/offers",
            offerModel
            //querystring.stringify(offerModel)

        ).then((response)=>{
            console.log(response);
            //TODO после получения ответа от сервера, необходимо пробросить новое значение в store , а если ошибка, отобразить это в Editable поле.
            this.throwNewOffer(offerModel)
        })
    }

    throwNewOffer(offer){
        if(this.props.onChangeOffer !== undefined){
            this.props.onChangeOffer(offer)
        }
    }



    render(){
        let {data} = this.props;

        let title = "Открыть привязку";
        let className = "no-pointer";
        if(data.offerId == null ){
            title = null;
            // className += " no-pointer";
        }

        let classNameModal = "big-modal modal-bindings";
        if(this.state.fetching){
            classNameModal += " fetching";
        }

       // console.log("this.state.data",this.state.data);
        return(
            <React.Fragment>
                <tr className={className} >
                    <td>
                        {
                            data.offerId !== null?
                                <Checkbox
                                    value={this.props.checked}
                                    onChange={(checked)=>{this.handleCheckboxChange(checked)}}
                                />
                                :null
                        }

                    </td>
                    <td
                        title={title}
                        onClick={()=>this.handleBarcodeClick()}
                        className="cursor-pointer"
                    >{data.offerBindToId}</td>
                    <td
                        title={title}
                        onClick={()=>this.handleProductClick()}
                        className="cursor-pointer"
                    >
                        {data.offerBindToName }
                    </td>
                    <td>{data.offerName }</td>

                    <td>
                        {
                                <EditableText
                                    value={data.coefficient}
                                    onSave={(value)=>this.handleOnSaveOffer("coefficient",value)}
                                    require={true}
                                    nullText="нет привязки"
                                />
                        }
                    </td>
                    <td>
                        {
                                <EditableText
                                    value={data.offerId}
                                    onSave={(value)=>this.handleOnSaveOffer("offerId",value)}
                                    require={true}
                                    nullText="нет привязки"
                                />
                        }

                    </td>
                    <td>
                        {
                            data.url !== null && data.offerBindToUrl.length > 0 ?
                                <a target="_blank" href={data.offerBindToUrl} title="Перейти на сайт компании. В новом окне" onClick={(e)=>e.stopPropagation()}>Ссылка на товар</a>
                                : "нет ссылки"
                        }

                    </td>
                    <td>
                        {
                            data.url !== null && data.url.length > 0 ?
                                <a target="_blank" href={data.url} title="Перейти на сайт конкурента. В новом окне" onClick={(e)=>e.stopPropagation()}>Ссылка на товар конкурента</a>
                                : "нет ссылки"
                        }

                    </td>
                    <td>
                        {
                            data.isAutoBinded ?
                                <i className="fa fa-laptop text-warning-300" title="автоматическая привязка"></i>
                                :null
                        }

                    </td>
                    <td>{data.price}</td>
                    <td>{data.companyPrice}</td>
                    <td>{moment(data.updated).format('DD.MM.YYYY hh:mm')}</td>
                </tr>
                <Modal
                    bssize={"large"}
                    show={this.state.modalDetailsIsOpen}
                    onHide={()=> this.closeModal()}
                    aria-labelledby="contained-modal-title-lg"
                    className={classNameModal}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id='ModalHeader'>Детали</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="modal-details"><pre lang="xml" >{data.offerDetails}</pre></div>
                    </Modal.Body>

                </Modal>
                <Modal
                    bssize={"large"}
                    show={this.state.modalIsOpen}
                    onHide={()=> this.closeModal()}
                    aria-labelledby="contained-modal-title-lg"
                    className={classNameModal}
                    
                >
                    <Modal.Header closeButton>
                        <Modal.Title id='ModalHeader'>Привязка</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className=" main-offer">
                            {
                                data.offerBindToImg ?
                                    <div className="image">
                                        <div className="thumbnail">

                                            <ImageZoom
                                                defaultStyles={{
                                                    zoomContainer:{
                                                        zIndex:1050
                                                    }
                                                }}
                                                image={{
                                                    src: data.offerBindToImg,
                                                    //alt: 'Golden Gate Bridge',
                                                    className: 'img',
                                                    // style: {
                                                    //     width: '100px'
                                                    // }
                                                }}
                                                zoomImage={{
                                                    src: data.offerBindToImg,
                                                  //  alt: 'Golden Gate Bridge'
                                                }}
                                            />
                                        </div>
                                    </div>
                                    :null
                            }

                            <div className="desc">
                                <div className="copyable  name" onClick={(e)=>{this.handleCopyName(e)}}>{data.offerBindToName} <i className="icon-copy3"></i></div>
                                <div className="id">{data.offerBindToId}</div>
                            </div>
                        </div>

                        <div>
                            <input
                                className="form-control"
                                placeholder="Название товара"
                                onChange={(e)=>this.handleSearchChange(e)}
                                value={this.state.searchText}
                            />
                        </div>
                        <div>
                            <input
                                className="form-control"
                                placeholder="Артикул"
                                onChange={(e)=>this.handleBarcodeChange(e)}
                                value={this.state.barcode}
                            />
                        </div>
                        <div>
                                {
                                    this.state.data.map((item,index)=>{
                                        let itemClassName = "binding-item";
                                        if(item.offerId === this.state.offerId){
                                            itemClassName += " active"
                                        }

                                        return(

                                            <div key={index} className={itemClassName}>
                                                <div className="row">
                                                    <div className="col-md-9">
                                                        <div className="images">
                                                            {
                                                                item.offerDetails.pictures.map((elem,key)=>{
                                                                    return(
                                                                        <div key={key} className="thumbnail">

                                                                            <ImageZoom
                                                                                onClick={(e)=>{
                                                                                    e.preventDefault()
                                                                                    //   return true
                                                                                }}
                                                                                defaultStyles={{
                                                                                    zoomContainer:{
                                                                                        zIndex:1050
                                                                                    },
                                                                                    zoomImage:{
                                                                                        objectFit:"contain"
                                                                                    }
                                                                                }}
                                                                                image={{
                                                                                    src: elem,
                                                                                    //alt: 'Golden Gate Bridge',
                                                                                    className: 'img',
                                                                                    // style: {
                                                                                    //     width: '100px'
                                                                                    // }
                                                                                }}
                                                                                zoomImage={{
                                                                                    src: elem,
                                                                                    width:'100%',
                                                                                    height:'100%'
                                                                                    //  alt: 'Golden Gate Bridge'
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                        <div className="desc">
                                                            <div className="name">
                                                                {
                                                                    item.offerDetails.url ?
                                                                        <a href={item.offerDetails.url} target="_blank" rel="nofollow noopener" title="Открыть сайт в новом окне">{item.offerDetails.name} <i className="icon-new-tab"></i></a>
                                                                        :
                                                                        <span>{item.offerDetails.name}</span>
                                                                }

                                                            </div>
                                                            <div className="offerId">ID: {item.offerId}</div>
                                                            <div className="price">
                                                                {
                                                                    item.offerDetails.price != 0?
                                                                        <div>
                                                                        Цена:
                                                                        {
                                                                            item.offerDetails.oldPrice?
                                                                            <span className="old-price">{item.offerDetails.oldPrice} р.</span>
                                                                            :null
                                                                        }
                                                                    <span className="">{item.offerDetails.price} р.</span>
                                                                        </div>
                                                                    :
                                                                        "нет в наличии"
                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <button className="btn btn-default"  onClick={()=>this.handleBindingClick(item.offerId)}><i className="icon-link2"></i> привязать</button>

                                                    </div>
                                                </div>



                                            </div>
                                        )
                                    })
                                }

                            <Pager
                                key={2}
                                pager={{
                                    page: this.state.page,
                                    count: this.state.size,
                                    total: this.state.total
                                }}
                                onPageChange={(pager) => this.handlePagerChange(pager)}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>

                        <Modal.Dismiss className='btn btn-warning'>Отмена</Modal.Dismiss>


                        <button className='btn btn-primary' onClick={()=>this.saveModal()}>
                            Сохранить
                        </button>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>
        )
    }
}

export default Product;


// WEBPACK FOOTER //
// ./src/components/Company/Product.jsx